(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["entrance"] && !Shopify.designMode) return;
  try {
    
  // $(document).on('ready Profile.OrderCountUpdated', function(e){
  //   var ordercnt = getCookie('fe_ordercnt') || 0;
  //   if(ordercnt > 0){
  //     $("#entrance-newuser").hide();
  //     $("#entrance-buyer").show();
  //   }
  //   else {  
  //     $("#entrance-buyer").hide();
  //     $("#entrance-newuser").show();
  //   }
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floor-switch"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    var html = '';
    $('.floor-section').each(function(index, element) {
      var name = $(element).find('.floor-scope').attr('data-floor-name');
      html += `<div class="floor-nav-item">
          <span class="item__index">${name}</span>
        </div>`;
    })
    $('#floor-nav').append($(html));

    var floorNav = $('#floor-nav');//导航壳
    var floorNavItem = floorNav.find('.floor-nav-item');//导航
    var floorScope = $('main .floor-section');//楼层
    var goTopBtn = $('#go-top'); //回到顶部
    
    var fadeout = null;
    
    $(window).scroll(function(){
      if(fadeout != null){
        window.clearTimeout(fadeout);
      }

      var winWidth = $(window).width();//可视窗口宽度
      var winHeight = $(window).height();//可视窗口高度
      var scrollTop = $(window).scrollTop();//鼠标滚动的距离
      
      // 正在滚动
      if(scrollTop>=$('#shopify-section-header').height()){
        if(!theme.mobile){
          floorNav.fadeIn();
        }
        //鼠标滑动式改变
        var activeIndex = 0;
        floorScope.each(function(index){
          if($(this).offset().top - scrollTop <= winHeight/2){
            floorNavItem.removeClass('active');
            floorNavItem.eq(index).addClass('active');
            activeIndex = index;
          }
        })
        if(!theme.mobile){
          fadeout = window.setTimeout(function(){
            floorNav.fadeOut();
          },1000);
        }
        else{
          fadeout = window.setTimeout(function(){
            $('.floor-switch').animate({scrollLeft:activeIndex*60});
          },50);
        }
      }else{
        if(!theme.mobile){
          floorNav.fadeOut();
        }
      }
    })

    floorNavItem.on('mouseenter mouseover', function() {
      if(theme.mobile){
         return;
      }
      if(fadeout != null){
        window.clearTimeout(fadeout);
      }
      var itemName = $(this).find('.item__name');
      itemName.fadeIn();
    });
  
    floorNavItem.on('mouseleave', function() {
      if(theme.mobile){
         return;
      }
      var itemName = $(this).find('.item__name');
      setTimeout(() => {
        itemName.fadeOut();
      }, 1000);
    
      fadeout = window.setTimeout(function(){
        floorNav.fadeOut();
        goTopBtn.fadeOut();
      },3000);
    });
    
    //点击回到当前楼层
    floorNavItem.click(function(){
      var t = floorScope.eq($(this).index()).offset().top - 150;
      $('body,html').animate({"scrollTop":t}, 500);
      floorNavItem.removeClass('active');   
      $(this).addClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oem-parts-notice"] && !Shopify.designMode) return;
  try {
    
$(document).on('Notice.Inited', function(){
  var model = getUrlParam('_model_');
  if(!model && '{{ section.settings.default_show }}'){
    $('#tooltip-oem-guide').click();
  };
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile"] && !Shopify.designMode) return;
  try {
    
  function saveVehiclesToServer(account, vehicles_data) {
    var vehicles = []
    $.each(Object.values(vehicles_data), function(index, each){
        vehicles.push(each.join('_'));
    })
    if(account && vehicles.length > 0){
        $.post(
          'https://apps.freedomenduro.cn/customer/set_profile',{ 
              account: account, 
              vehicles: vehicles.join(',')
          },
          function (response) {
              ;//console.log(response)
          }
        );
    }
  }
    
  function fetchVehiclesFromServer(account) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: `https://apps.freedomenduro.cn/customer/get_profile?account=${account}`,
        type: 'GET',
        dataType: 'json',
        success: function (response) {
          var vehicles_from_api = {};
          if(response['success'] && response['data']['vehicles']) {
            var vehicles = response['data']['vehicles'].split(',');
            vehicles.sort();
            vehicles.reverse();
            $.each(vehicles, function(index, each){
              var fields = each.split('_');
              vehicles_from_api[fields[2]] = fields;
            })
          }
          resolve(vehicles_from_api);
        },
        error: function (xhr, status, error) {
          reject(error);
        }
      });
    });
  }
  
  $(document).ready(function(){
    // 长登陆：设备ID 未登陆用户的车型保存到服务端需要用到
    if(!getCookie('fe_token') || getCookie('fe_token') == 'null') {
      setCookie('fe_token', getCookie('_y') || '');
    }
    // 长登陆：account
    if($('#global-account').val()) {
      setCookie('fe_account', $('#global-account').val());
    }
    // 是否新用户/用户订单数
    var ordercnt = $('#global-ordercnt').val() || 0;
    
    // 登录账号/邀请者/俱乐部
    // var device = getCookie('fe_token');
    var account = getCookie('fe_account') || '';
    var inviter = getUrlParam('inviter') || getUrlParam('account'); 
    var dealer = getUrlParam('shop') || getCookie('fe_dealer');
    
    // 0. 是否dealer
    var accounts = [] 
    if(account){
      //console.log('account:'+account);
      accounts.push(account);
    }
    if(inviter){
      //console.log('inviter:'+inviter);
      accounts.push(inviter);
      $("#inviter_id").val(inviter);
    }
    if(dealer){
      //console.log('dealer:'+dealer);
      accounts.push(dealer);
      $("#shop_id").val(dealer);
    }
    
    if(accounts.length > 0){
      $.ajax({
        url: 'https://apps.freedomenduro.cn/customer/get_dealer?accounts='+accounts.join(','),
        method: 'GET',
        success: function(response) {
          if(response.success && response.data && response.data.shop_name) {
            if(response.data.account != getCookie('fe_dealer')){
              setCookie('fe_dealer', response.data.account);
              $(document).trigger('Profile.DealerUpdated');
            }
            // customers
            if(response.data.account != account){
              $("#global-shop-title").text(response.data.shop_name)
              $("#global-logo-left").show();
              $("#global-logo-center").hide();
              $("#global-shop").show();
            }
            // dealers
            else {
              $("#global-dealer-title").text(response.data.shop_name)
              $("#global-logo-left").show();
              $("#global-logo-center").hide();
              $("#global-dealer").show();
            }
          }
        },
        error: function(xhr, status, error) {
          // 处理错误
          console.error(error);
        }
      });
    }
    
    // 1. 用户订单数量
    // if(ordercnt > 0){
    //   setCookie('fe_ordercnt', ordercnt);
    //   // 触发更新
    //   $(document).trigger('Profile.OrderCountUpdated');
    // }

    // 更新本地的车型数据
    var vehicles_from_local = JSON.parse(localStorage.getItem('fe_vehicle_data') || '{}');
    var general_model = getUrlParam('_general_model_');
    var model = getUrlParam('_model_');
    var make = getUrlParam('_make_');
    if(model && make && !vehicles_from_local[model]){
      vehicles_from_local[model] = [make, general_model, model];
      localStorage.setItem('fe_vehicle_data', JSON.stringify(vehicles_from_local));
    }

    if(account){
      fetchVehiclesFromServer(account).then(function(vehicles_from_server) {
        // 合并数据
        var vehicles_data = Object.assign(vehicles_from_server, vehicles_from_local);
        // 写回数据库
        saveVehiclesToServer(account, vehicles_data);
        // 清理本地
        localStorage.removeItem('fe_vehicle_data');
        // 触发更新
        $(document).trigger('Profile.VehicleUpdated', [vehicles_data]);
      })
    }
    else {
      $(document).trigger('Profile.VehicleUpdated', [vehicles_from_local]);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-vehicle-selection"] && !Shopify.designMode) return;
  try {
    
  var filters = {
    "make": "rb_filter_metafield_5636dc30d0e7c170dad956d059dc1677",
    "category_path": "filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87",
    "model": [
        "rb_filter_metafield_672219d8aaa95893bbd4e9f019a00f72",
        "rb_filter_metafield_7e7da200d1c7bcf4e65c266f4d6b4202",
        "rb_filter_metafield_1c8c3def67309e5360a31c92c500d376",
        "rb_filter_metafield_f3b9d5c8c7820c07dcef4c131c6c1a5c",
        "rb_filter_metafield_a650f2ad91f604a46c8a7083bf59f1c6",
        "rb_filter_metafield_cf27919a3e5d19b523351b90504f1217",
        "rb_filter_metafield_0746ec2e4eeff41361be081e73dd5945",
        "rb_filter_metafield_1f76bc57fa3f422ce56645924a6f882b",
        "rb_filter_metafield_059e8944fcdb5b6f60522721bc6e4936",
        "rb_filter_metafield_a1ec8da9d2f80fcc9ca3825ec2424061",
        "rb_filter_metafield_5d1c4133d925469c89d3ee58d732566a",
        "rb_filter_metafield_14177fb8b13908cb2f5cd7c79fa82e37",
        "rb_filter_metafield_7d3178878dd236f427e34eecb1cc903e",
        "rb_filter_metafield_0d54ba9e7f87ca5a3f005d3f5bc6746b",
        "rb_filter_metafield_3f6f76c4909149e3c66088ddf050e968",
        "rb_filter_metafield_a9fec6f6ecb092bbff979e1827978823",
        "rb_filter_metafield_e42c830b84453228d408a39fafb68cf6",
        "rb_filter_metafield_83db3e256caae204ba07228cfef7c721",
        "rb_filter_metafield_af97b27b5545395de7a5e9892381175f",
        "rb_filter_metafield_578553845ba6b686849a942b64427317"
    ],
    "pricetag": "rb_filter_variant_metafield_5791e1ea1bcd138123b74ec4eb89767f",
  }
  
  function initVehicleSelection(){
    var vehicle_data = {};
    $.ajax({
      url: 'https://resource.freedomenduro.cn/config/vehicle-202404231756.json',
      dataType: 'json',
      async: false,
      success: function(response){
        vehicle_data = response;
      }
    })
    return vehicle_data;
  }

  function initCategorySelection(){
    // 加载类目树
    var category_tree = [];
    $.ajax({
      url: 'https://resource.freedomenduro.cn/config/categories.json',
      dataType: 'json',
      async: false,
      success: function(response) {
        if (response.success) {
          category_tree = response.result.items;
          /** 
           * 为防止document.ready前已经刷新数据，这种情况下触发Searchanise.ResultsUpdated事件
           */
          if(Searchanise && Searchanise.GetWidgets
             && Searchanise.GetWidgets().searchResults 
             && Searchanise.GetWidgets().searchResults.getPrevData
             && Searchanise.GetWidgets().searchResults.getPrevData()) {
            // console.log('trigger Searchanise.ResultsUpdated');
            // $(document).trigger('Searchanise.ResultsUpdated');
          }
        } else {
          console.error('Failed to fetch category data');
        }
      },
      error: function() {
        console.error('Failed to fetch category data');
      }
    })
    return category_tree;
  }

  function updateStyleOptions(data){
    var style_names = {
      "Offroad": "越野/攀爬",
      "Street": "街车/ADV"
    }
  
    var make = $('.ymm-make-select').val();
    if(make && data['makes'][make]){
      $('.ymm-style-select').val('');
      $('.ymm-style-select option[value!=""]').remove(); 
      $.each(data['makes'][make], function(index, style){
        $('.ymm-style-select').append(`<option value="${style}">${style_names[style] || style}</option>`);
      })
    }
  }

  function updateGeneralModelOptions(data){
    var make = $('.ymm-make-select').val();
    var style = $('.ymm-style-select').val();
    if(make){
      $('.ymm-general-model-select').val('');
      $('.ymm-general-model-select option[value!=""][value!="more"]').remove(); 
      $.each(data['models'], function(model, info){
        if(model.startsWith(make) && (!style || !info['styles'] || info['styles'].split(',').indexOf(style)>=0)){
          if(info['score'] > 0){
            $('.ymm-general-model-select').append('<option value="'+model+'">'+model+' 🌟</option>');
          }
          else {
            $('.ymm-general-model-select').append('<option value="'+model+'">'+model+'</option>');
          } 
        }
      });
    }
  }
  
  function updateModelYearOptions(data){
    var general_model = $('.ymm-general-model-select').val();
    if(general_model){
      $('.ymm-model-year-select').val('');
      $('.ymm-model-year-select option[data-init!="true"]').remove(); 
      $('.ymm-model-year-select').append('<option value="'+general_model+'">不限年份</option>');
      $.each(data['models'][general_model]['models'], function(model, info){
        $('.ymm-model-year-select').append('<option value="'+model+'">'+model.replace(general_model+' ', '')+'</option>');
      });
      $('.ymm-model-year-select').val(general_model);
    }
  }

  function search(data, _make, _general_model, _model, query) {
    // console.log(data,_make,_general_model,_model,query);
    var landingPageUrl = '/pages/search-results-page?rb_filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87=216';
    if(window.__sales_parts_page__){
      landingPageUrl = window.location.pathname;
    }
    if(_make){
      landingPageUrl = generateUrl(landingPageUrl, filters['make'], _make);
      landingPageUrl = generateUrl(landingPageUrl, '_make_', _make);
    }
    if(_general_model && _model && data['models'][_general_model]) {
      var bucket = data['models'][_general_model]['bucket'];
      if(_general_model != _model && data['models'][_general_model]['models'][_model]){
        bucket = data['models'][_general_model]['models'][_model]['bucket'];
      }
      landingPageUrl = generateUrl(landingPageUrl, filters['model'][bucket], _model);
      landingPageUrl = generateUrl(landingPageUrl, '_general_model_', _general_model);
      landingPageUrl = generateUrl(landingPageUrl, '_model_', _model);
    }
    landingPageUrl = generateUrl(landingPageUrl, 'rb_stock_status', '有库存|国外期货');
    landingPageUrl = generateUrl(landingPageUrl, 'page', '1');
    
    if(!window.__sales_parts_page__){
      if(query){
        landingPageUrl = generateUrl(landingPageUrl, 'q', query);
      } 
      else{
        landingPageUrl = generateUrl(landingPageUrl, 'q', _make);
      }
    }
    var priceTagParam = getUrlParam(filters['pricetag']);
    if(priceTagParam) {
      landingPageUrl = generateUrl(landingPageUrl, filters['pricetag'], priceTagParam);
    }
    window.location.assign(landingPageUrl);
  }

  function initEvent(vehicles){
    $('.btn-vehicle-open').click(function(){
      MicroModal.show('vehicle-modal');
    })
    
    $('.btn-vehicle-close').click(function(){
      MicroModal.close('vehicle-modal');
    })

    if(window.__sales_parts_page__){
      $('.vehicle-query').hide();
    }

    // 1. 初始化select
    var general_model = getUrlParam('_general_model_');
    var model = getUrlParam('_model_');
    var make = getUrlParam('_make_');
    var query = getUrlParam('q');

    // 如果query和make一致，将query置空
    if(query && make && query.toLowerCase() == make.toLowerCase()){
      console.log('query equals make, set query empty')
      query = '';
    }

    // 校验车型
    if(model){
      if(!general_model || !vehicles['models'][general_model]){
        console.log('校验车型失败');
        model = '';
      }
      else if(model != general_model && !vehicles['models'][general_model]['models'][model]){
        console.log('校验车型失败');
        model = '';
      }
    }

    // 初始化：make选项
    $.each(vehicles['makes'], function(make, styles){
      $(".ymm-make-select").append(`<option value="${make}">${make}</option>`)
    })

    // 初始化：已选中车型
    if(model){
      // 顶部样式
      $('#global-vehicle-title').text(model);
      $(window).unbind('scroll');
      $(window).scroll(function() {
        if ($(window).scrollTop() > 50) {
          $('#global-logo-header').hide();
          $('#global-logo-vehicle').fadeIn();
        }
        else {
          $('#global-logo-vehicle').hide();
          $('#global-logo-header').fadeIn();
        }
      });
    }

    // 初始化：关键词
    if(query){
      $(".ymm-search-query").val(query);
    }
    
    // 2. 用户操作select
    $('.ymm-make-select').unbind('change');
    $('.ymm-make-select').change(function(){
      updateStyleOptions(vehicles);
      updateGeneralModelOptions(vehicles);
    })

    $('.ymm-style-select').unbind('change');
    $('.ymm-style-select').change(function(){
      updateGeneralModelOptions(vehicles);
    })

    $('.ymm-general-model-select').unbind('change');
    $('.ymm-general-model-select').change(function(){
      updateModelYearOptions(vehicles);
    })

    // 3.1 触发搜索
    // 键盘
    $('.ymm-search-query').unbind('keydown');
    $('.ymm-search-query').keydown(function(e){
      if (e.keyCode === 13 || e.keyCode === 10) {
        var _make = make;
        var _general_model = general_model;
        var _model = model;
        var _query = $(".ymm-search-query").val();
        search(vehicles, _make, _general_model, _model, _query);
      }
    });

    // 按钮
    $('.ymm-search-btn').unbind('click');
    $('.ymm-search-btn').click(function(){
      var _make = make;
      var _general_model = general_model;
      var _model = model;
      var _query = $(".ymm-search-query").val();
      search(vehicles, _make, _general_model, _model, _query);
    });

    // 3.2 弹窗：重新选择车型
    $('.ymm-select-btn').unbind('click');
    $('.ymm-select-btn').click(function(){
      var _make = $('.ymm-make-select').val();
      var _general_model = $('.ymm-general-model-select').val();
      var _model = $('.ymm-model-year-select').val();
      search(vehicles, _make, _general_model, _model, query);
    });

    // 3.3 下拉：重新选择车型
    $('.vehicle-selector select').unbind('change');
    $('.vehicle-selector select').change(function(e){
      var value = $(this).val();
      if(value == 'more') {
        $('.vehicle-selector select').val('');
        MicroModal.show('vehicle-modal');
        return;
      } 
      var _make = $(this).find("option:selected").data("make");
      var _general_model = $(this).find("option:selected").data("general-model");
      var _model = $(this).find("option:selected").data("model");
      
      search(vehicles, _make, _general_model, _model, query);
    })
  }

  function updateVehicles(vehicles_data){
    var general_model = getUrlParam('_general_model_');
    var model = getUrlParam('_model_');
    var make = getUrlParam('_make_');
    
    // 初始化：有历史车型 则增加选项
    var vehicles = Object.values(vehicles_data);
    if(vehicles.length > 0){ 
      $('.vehicle-selector select option[data-init!="true"]').remove();
      $.each(vehicles, function(index, vehicle){
          $('.vehicle-selector select option[value=""]').after(`<option data-make="${vehicle[0]}" data-general-model="${vehicle[1]}" data-model="${vehicle[2]}" value="${vehicle[2]}">${vehicle[2]}</option>`)
      })  
    } 

    // 选中车型
    $('.vehicle-selector select').val(model);
  }

  function updateNotice(){
     var totalItems = -1;
     var totalFitmakes = -1;
     var results = Searchanise.GetWidgets().searchResults;
     if(results && results.getPrevData() && results.getPrevData().result){
       totalItems = results.getPrevData().result.totalItems;
       if(results.getPrevData().result.correctedQuery){
         totalItems = 0;
       }
       $.each(results.getPrevData().result.facets, function(index, each){
         if(each['title'] == '适配品牌'){
           totalFitmakes = each['buckets'].length;;
         }
       })
     }
     // 没有选择车型时出提示，分成两种情况：有query和没有query
     if(!getUrlParam('_model_')){
       // 没有query
       if(!getUrlParam('q')){
         $('.vehicle-notice').text('请先选择车型得到适配结果👇');
       }
       // 有query
       else if(totalFitmakes > 0){
         $('.vehicle-notice').text('查询结果中包含多款车型，请选择车型👇');
       }
     }
     // 已经选择车型时，分成两种情况：结果太多和结果太少
     else {
       // 如果结果太多，并且没有用关键词/分类
       var category = getUrlParam('rb_filter_metafield_e0ca6c2fc539feea10c5d7cc786b0b87');
       if(totalItems > 20 && (!getUrlParam('q') || getUrlParam('q') == getUrlParam('_make_')) && (!category || category == 216) && !getUrlParam('rb_vendor')){
         $('.vehicle-notice').text('您可通过关键词和分类进一步筛选👇');
       }
       // 如果无结果，提示用相似车型筛选（或者不选年份）
       else if(totalItems == 0) {
         $('.vehicle-notice').text('查询无结果，请调整关键词或选择相似车型重新查询👇');
       }
       else {
         $('.vehicle-notice').text('');
       }
     }
  }

  function clearHeaderSearchBox(){
     if($('.vehicle-query').is(":visible")){
        $('.search-form-header input').val('');
     }
  }
  
  $(document).on('ready', function(){
    // var categories = initCategorySelection();
    var vehicles = initVehicleSelection();
    initEvent(vehicles);
  })

  $(document).on('Profile.VehicleUpdated', function(event, param){
    // console.log(param);
    updateVehicles(param);
  })

  $(document).on('Searchanise.ResultsUpdated', function(){
     updateNotice();
     clearHeaderSearchBox();
  })


  } catch(e) { console.error(e); }
})();
})();
